export enum EExamStatus {
  Waiting = 'waiting',
  InProgress = 'in_progress',
  DataCollection = 'data_collection',
  Finished = 'finished',
  Confirmed = 'confirmed',
  Canceled = 'canceled',
  UnKnow = ''
}

export const EExamStatusColor: any = {
  [EExamStatus.Canceled]: 'red',
  [EExamStatus.Confirmed]: 'lime',
  [EExamStatus.Waiting]: 'yellow',
  [EExamStatus.InProgress]: 'blue',
  [EExamStatus.Finished]: 'green',
  [EExamStatus.DataCollection]: 'cyan'
}
